import { Button, Link, Spinner, Table, Text, VStack } from "@chakra-ui/react"
import {
  AUGMENTATION_PANEL_ACTION_BUTTON_PROPS,
  AUGMENTATION_PANEL_STATIC_TEXT_PROPS,
  AUGMENTATION_PANEL_TYPOGRAPHY_CSS
} from "@pathwright/ux/src/components/augmentation/augmentationPanelStyles"
import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import Tooltip from "@pathwright/ux/src/components/tooltip/Tooltip"
import { useUserPaymentHistoryQuery } from "@pathwright/graphql-client/src/generated"

const tPrefix = "payment_history"

export function useUserPaymentHistoryItems() {
  const userPaymentHistoryQuery = useUserPaymentHistoryQuery()
  const payments =
    userPaymentHistoryQuery.data?.me?.payment_history?.payments || []
  // Filtering out $0 payments.
  return payments.filter((payment) => payment.total > 0)
}

function UserAugmentationPaymentHistory() {
  const { t } = useTranslate()
  const userPaymentHistoryQuery = useUserPaymentHistoryQuery()
  const paymentHistory = userPaymentHistoryQuery.data?.me?.payment_history
  const payments = useUserPaymentHistoryItems()

  return (
    <VStack
      w="100%"
      minH="100%"
      p="augmentationPanel"
      pb={4}
      align="stretch"
      gap="augmentationPanel"
      css={AUGMENTATION_PANEL_TYPOGRAPHY_CSS}
    >
      {userPaymentHistoryQuery.loading ? (
        <Spinner />
      ) : (
        <>
          <Table.Root variant="line" size="sm" w="100%" cellPadding={1}>
            <Table.Header fontWeight="bold">
              <Table.Row>
                <Table.Cell
                  {...AUGMENTATION_PANEL_STATIC_TEXT_PROPS}
                  fontWeight="bold"
                >
                  {t(`${tPrefix}.item`)}
                </Table.Cell>
                <Table.Cell
                  {...AUGMENTATION_PANEL_STATIC_TEXT_PROPS}
                  fontWeight="bold"
                >
                  {t(`${tPrefix}.total`)}
                </Table.Cell>
                <Table.Cell
                  {...AUGMENTATION_PANEL_STATIC_TEXT_PROPS}
                  fontWeight="bold"
                >
                  {t(`${tPrefix}.date`)}
                </Table.Cell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {payments.map((payment, index) => (
                <Table.Row key={index}>
                  <Tooltip title={payment.item}>
                    <Table.Cell>
                      <Text lineClamp={1} textStyle="augmentationPanel" m={0}>
                        {payment.item}
                      </Text>
                    </Table.Cell>
                  </Tooltip>
                  <Table.Cell>
                    <Text textStyle="augmentationPanel" m={0}>
                      {payment.currency_display}
                    </Text>
                  </Table.Cell>
                  <Table.Cell>
                    <Text textStyle="augmentationPanel" m={0}>
                      {/* Formats like 06/04/2025 */}
                      {new Date(payment.date).toLocaleDateString(undefined, {
                        month: "2-digit",
                        day: "2-digit",
                        year: "numeric"
                      })}
                    </Text>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table.Root>
          <Button
            asChild
            {...AUGMENTATION_PANEL_ACTION_BUTTON_PROPS}
            bg="augmentationPanel.fill.muted"
            color="augmentationPanel.text"
            _hover={{ bg: "augmentationPanel.fill.strong" }}
            w="full"
          >
            <Link href={paymentHistory?.download_url}>
              <Pathicon icon="download" />
              {t(`${tPrefix}.download_history`)}
            </Link>
          </Button>
        </>
      )}
    </VStack>
  )
}

export default UserAugmentationPaymentHistory
